export default __webpack_public_path__ + "static/media/Type H main cover.6c181db4.png";